var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModuleWrapper',{attrs:{"instance":_vm.instance,"backgroundColor":_vm.backgroundColor}},[_c('p',[_vm._v("Modal Header ("+_vm._s(_vm.instance['modalId'])+")")]),_vm._v(" "),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }